/* globals zc Backbone */

(function () {
  'use strict'

  zc.collections.Messages = Backbone.Collection.extend({
    model: zc.models.Message
  })
})()
